import { useNavigate } from 'react-router-dom'
import PlannedExpertiseStepper from './PlannedExpertiseStepper'
import { useState } from 'react'
import PlannedExpertiseAbandonDialog from './PlannedExpertiseAbandonDialog'
import {
    usePostIdsHealthcareservicesHcsIdTransmissions,
    useGetIdsUsersCurrent,
} from '@toktokdoctech/tokapi-client'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import { useAppDispatch } from '../../../store'
import { displaySnackbar } from '../../../actions/main'
import type { PlannedExpertiseStepperRecap } from './_props'

export const PlannedExpertiseCreation = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const currentHcs = useCurrentHcs()
    const { data: currentUser } = useGetIdsUsersCurrent()
    const [recapData, setRecapData] = useState<PlannedExpertiseStepperRecap | null>(null)
    const [isAbandonDialogOpen, setIsAbandonDialogOpen] = useState(false)

    const { mutateAsync: createTransmission, isPending } =
        usePostIdsHealthcareservicesHcsIdTransmissions()

    const handleComplete = async () => {
        if (!recapData?.patientId || !recapData?.requesterId || !recapData?.requiredExpertId || !recapData?.workflowId) {
            dispatch(
                displaySnackbar(
                    'error',
                    'Informations incomplètes pour créer la téléexpertise',
                    undefined,
                    '[PlannedExpertiseCreation] missing required data',
                ),
            )
            return
        }

        if (!currentUser?.id) {
            dispatch(
                displaySnackbar(
                    'error',
                    'Utilisateur non connecté',
                    undefined,
                    '[PlannedExpertiseCreation] no current user',
                ),
            )
            return
        }

        try {
            const response = await createTransmission({
                hcsId: currentHcs.id,
                data: {
                    patient: { id: recapData.patientId },
                    requester: { id: recapData.requesterId },
                    requiredExpert: { id: recapData.requiredExpertId },
                    workflow: { id: recapData.workflowId },
                    careGiver: { id: currentUser.id },
                },
            })

            dispatch(
                displaySnackbar(
                    'success',
                    'La téléexpertise a bien été créée !',
                    undefined,
                    '[PlannedExpertiseCreation] transmission created',
                ),
            )

            const transmissionId = response.transmissionId
            navigate(`/teleexpertise/workflow/${transmissionId}`, {
                state: { recap: recapData },
            })
        } catch (error) {
            console.error('[PlannedExpertiseCreation] create transmission error', error)
            dispatch(
                displaySnackbar(
                    'error',
                    'Erreur lors de la création de la téléexpertise',
                    undefined,
                    '[PlannedExpertiseCreation] create transmission failed',
                ),
            )
        }
    }

    const handleAbandon = () => {
      setIsAbandonDialogOpen(true)
    }

    return (
        <>
            <PlannedExpertiseStepper
                onComplete={handleComplete}
                onAbandon={handleAbandon}
                onRecapChange={setRecapData}
                isLoading={isPending}
            />
            <PlannedExpertiseAbandonDialog
                isOpen={isAbandonDialogOpen}
                onClose={() => setIsAbandonDialogOpen(false)}
                onConfirm={() => navigate('/teleexpertises')}
                mode="stepper"
            />
        </>
    )
}
